
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
:host .slh-modal {
  font-family: var(--slh-default-font-family, "Open Sans");
  opacity: 0;
  visibility: hidden;
  z-index: -100000;
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  padding: 32px 24px;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  transition: opacity 0.3s, visibility 0.3s;
  border-radius: 16px;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  width: 560px;
  max-height: calc(80% - 80px);
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
:host .slh-modal.fluid {
  width: max-content;
  max-width: calc(80% - 32px);
}
:host .slh-modal .modal-content-holder {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-content: space-between;
  width: 100%;
}
:host .slh-modal .slh-modal-content {
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 16px;
  scrollbar-width: thin;
  scrollbar-color: var(--slh-color-neutral-shade-40, #C0C8D8) var(--slh-color-neutral-shade-00, #FFFFFF);
  margin-top: 8px;
}
:host .slh-modal .slh-modal-content::-webkit-scrollbar {
  width: 4px;
}
:host .slh-modal .slh-modal-content::-webkit-scrollbar-track {
  background: #FFFFFF;
  width: 4px;
}
:host .slh-modal .slh-modal-content::-webkit-scrollbar-thumb {
  background-color: var(--slh-color-neutral-shade-40, #C0C8D8);
  border-radius: 50px;
}
:host .slh-modal .content {
  width: 100%;
  height: auto;
}
:host .slh-modal slot[name=title] {
  display: none;
}
:host .slh-modal slot[name=title]::slotted(*):nth-child(1) {
  margin-bottom: 0;
}
:host .slh-modal h3 {
  color: var(--slh-color-neutral, #39455D);
  font-size: var(--slh-base-xl-font-size, 24px);
  line-height: 40px;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  margin: 0;
}
:host .slh-modal.modal-has-title h3 {
  margin: 0;
}
:host .slh-modal p {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host .slh-modal slot[name=content]::slotted(*):nth-child(1) {
  margin-top: 0;
}
:host .slh-modal slot[name=icon]::slotted(*) {
  max-height: 160px;
}
:host .slh-modal slot[name=icon]::slotted(.icon-wrapper) {
  fill: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host .slh-modal.opened {
  display: flex;
  opacity: 1;
  z-index: 10000;
  visibility: visible;
}
:host .slh-modal .close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: transparent;
  outline: none;
  border: 0;
  cursor: pointer;
  padding: 0;
  display: inline-block;
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}

:host(.modal-has-buttons) .modal--buttons {
  display: flex;
  margin-top: 32px;
  justify-content: left;
  box-sizing: border-box;
  padding: 0 16px;
}
:host(.modal-has-buttons) .modal--buttons slh-button, :host(.modal-has-buttons) .modal--buttons slot[name=buttons]::slotted(.button-wrapper) {
  margin-right: 8px;
}
:host(.modal-has-buttons) .modal--buttons slot[name=buttons]::slotted(.button-wrapper:last-child) {
  margin-right: 0;
}

.slh-overlay {
  transform: scale(0);
  transform-origin: center;
  opacity: 0;
  visibility: hidden;
  z-index: -100000;
}
.slh-overlay.opened {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--slh-color-neutral-shade-80-opacity-90, rgba(78, 94, 126, 0.9));
  transform: scale(1);
  opacity: 1;
  z-index: 10000;
  visibility: visible;
}

@media screen and (max-width: 560px) {
  :host .slh-modal {
    width: calc(100% - 32px);
    padding: 32px 12px;
  }
  :host .slh-modal .slh-modal-content {
    padding: 0 12px;
  }
  :host .slh-modal .modal--buttons {
    padding: 0 12px;
  }
  :host .slh-modal.fluid {
    max-width: calc(100% - 32px);
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
:host .slh-modal {
  box-sizing: border-box;
  filter: none;
}
:host .slh-modal h3 {
  color: var(--slh-color-neutral, #39455D);
}
:host .slh-modal slot[name=content]::slotted(p) {
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
}

@media screen and (max-width: 560px) {
  .modal--buttons {
    left: 0;
    width: 100%;
  }
}
`;
